import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@td/shared_utils';
import classnames from 'classnames';

import { SortDirectionIcon } from '../../../icons';

const ManagedMedicationsTableHeader = ({ headerName, isSortable, sortParams, changeSort }) => {
  const onClick = () => {
    if (sortParams.sortBy !== headerName) {
      changeSort({ order: 'ASC', sortBy: headerName });

      return;
    }

    const newOrder = sortParams.order === 'ASC' ? 'DESC' : 'ASC';

    changeSort({ order: newOrder, sortBy: headerName });
  };

  const sortableProps = { onClick };

  return (
    <div className={classnames('table-header', { sortable: isSortable })} {...(isSortable && sortableProps)}>
      <span>
        <I18n scope="medication_formularies.table.headers" text={headerName} />
      </span>
      {isSortable && <SortDirectionIcon sortDirection={sortParams.sortBy === headerName ? sortParams.order : null} />}
    </div>
  );
};

ManagedMedicationsTableHeader.propTypes = {
  headerName: PropTypes.string.isRequired,
  isSortable: PropTypes.bool,
  sortParams: PropTypes.shape({
    order: PropTypes.oneOf(['ASC', 'DESC']),
    sortBy: PropTypes.oneOf(['drug_id', 'drug_name', 'managed_drug_lists'])
  }),
  changeSort: PropTypes.func
};

ManagedMedicationsTableHeader.defaultProps = {
  isSortable: true
};

export default ManagedMedicationsTableHeader;
